import React from 'react'
import MerchantListDataTable from '../../components/Admin/MerchantList';

const MerchantList = () => {
  return (
    <MerchantListDataTable />
  )
}

export default MerchantList;